// Import shared assets from CreateEventLandingPage
import marySImg from '../../CreateEventLandingPage/assets/mary_s.jpg';
import jordanPImg from '../../CreateEventLandingPage/assets/jordan_p.jpg';
import jamieTImg from '../../CreateEventLandingPage/assets/jamie_t.jpg';
import bradyOImg from '../../CreateEventLandingPage/assets/brady_o.jpg';
import westRImg from '../../CreateEventLandingPage/assets/west_r.jpg';
import dawnSImg from '../../CreateEventLandingPage/assets/dawn_s.jpg';
import logo3Step from '../../CreateEventLandingPage/assets/Logo_3Step.png';
import logoAAU from '../../CreateEventLandingPage/assets/Logo_AAU.png';
import logoAJGA from '../../CreateEventLandingPage/assets/Logo_American Junior Golf Association (AJGA).png';
import logoMichigan from '../../CreateEventLandingPage/assets/Logo_Michigan.png';
import logoPennState from '../../CreateEventLandingPage/assets/Logo_pennstate.png';
import logoPrepNetwork from '../../CreateEventLandingPage/assets/Logo_PrepNetwork.png';
import logoPrinceton from '../../CreateEventLandingPage/assets/Logo_Princeton University.png';
import logoTripleCrownSports from '../../CreateEventLandingPage/assets/Logo_TripleCrownSports.png';
import logoUSAFootball from '../../CreateEventLandingPage/assets/Logo_USA Football.png';
import logoUSClubSoccer from '../../CreateEventLandingPage/assets/Logo_USClubSoccer.png';

export const items = [
  {
    key: 1,
    name: 'Mary S.',
    location: 'Fairfield, CT',
    workedJobs: 368,
    image: marySImg,
  },
  {
    key: 2,
    name: 'Jordan P.',
    location: 'Dallas, TX',
    workedJobs: 113,
    image: jordanPImg,
  },
  {
    key: 3,
    name: 'Jamie T.',
    location: 'Orlando, FL',
    workedJobs: 237,
    image: jamieTImg,
  },
  {
    key: 4,
    name: 'Brady O.',
    location: 'San Jose, CA',
    workedJobs: 224,
    image: bradyOImg,
  },
  {
    key: 5,
    name: 'West R.',
    location: 'Montevideo, MN',
    workedJobs: 59,
    image: westRImg,
  },
  {
    key: 6,
    name: 'Dawn S.',
    location: 'Downingtown, PA',
    workedJobs: 176,
    image: dawnSImg,
  },
];

export const brandsLogo = [
  {
    imageUrl: logoUSClubSoccer,
    width: '100%',
    height: '120%',
  },
  {
    imageUrl: logoPennState,
    width: '60%',
    height: '80%',
    objectFit: 'cover',
  },
  {
    imageUrl: logo3Step,
    width: '100%',
    height: '100%',
  },
  {
    imageUrl: logoMichigan,
    width: '100%',
    height: '60%',
  },
  {
    imageUrl: logoPrepNetwork,
    width: '100%',
    height: '100%',
  },
  {
    imageUrl: logoTripleCrownSports,
    width: '100%',
    height: '100%',
  },
  {
    imageUrl: logoPrinceton,
    width: '100%',
    height: '100%',
  },
  {
    imageUrl: logoAAU,
    width: '100%',
    height: '90%',
  },
  {
    imageUrl: logoUSAFootball,
    width: '100%',
    height: '100%',
  },
  {
    imageUrl: logoAJGA,
    width: '100%',
    height: '90%',
  },
];
